import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useApiService } from '../services/useApiService';
import LoadingSpinner from '../components/LoadingSpinner';
import NaibLogo from '../components/NaibLogo';
import { KeyIcon } from '@heroicons/react/24/outline';
import { mapPublicAuthError } from '../utils/authErrorMessage';
import { appConfig } from '../config/appConfig';

function ForgotPassword() {
  const { auth } = useApiService();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await auth.forgotPassword(email, appConfig.productId);
      setSuccess(true);
    } catch (error) {
      setError(mapPublicAuthError(error, { actionLabel: 'password reset requests' }));
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6">
      <div className="pb-4">
          <NaibLogo logoClassName="h-9 w-9" nameClassName="h-7 w-auto max-w-[180px]" alt="Onahiri" />
        </div>

        {error && (
          <div className="rounded-md bg-red-50 p-4 text-center">
            <div className="text-sm text-red-700">{error}</div>
          </div>
        )}

        {success ? (
          <div className="rounded-md bg-green-50 p-4">
            <div className="text-sm text-green-700 text-center">
              Password reset instructions have been sent to your email.
              Please check your inbox.
            </div>
            <div className="mt-4 text-center">
              <Link
                to="/login"
                className="font-medium text-indigo-600 hover:text-indigo-500"
              >
                Return to login
              </Link>
            </div>
          </div>
        ) : (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="space-y-2">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <KeyIcon className="h-5 w-5 mr-2" />
                {loading ? 'Processing...' : 'Reset Password'}
              </button>
            </div>

            <div className="text-center">
              <Link
                to="/login"
                className="font-medium text-indigo-600 hover:text-indigo-500"
              >
                Back to login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword; 